import script from "./TaskDateRangePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskDateRangePicker.vue?vue&type=script&setup=true&lang=js"

import "./TaskDateRangePicker.vue?vue&type=style&index=0&id=450957f4&scoped=true&lang=css"
import "./TaskDateRangePicker.vue?vue&type=style&index=1&id=450957f4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-450957f4"]])

export default __exports__